import(/* webpackMode: "eager" */ "/app/src/app/company/careers/mobile-application-pentest/page.tsx");
